import Swiper from "swiper";
import { Navigation } from "swiper/modules";

Swiper.use([Navigation]);

function stylePeekingSlide(swiper) {
  // Remove any old peeking styles
  swiper.slides.forEach((slide) => slide.classList.remove("swiper-slide-peek"));

  // Find all visible slides
  const visibleSlides = Array.from(swiper.slides).filter((slide) =>
    slide.classList.contains("swiper-slide-visible")
  );
  
  if (visibleSlides.length > 1) {
    // The last visible is the peeker (right edge in LTR)
    visibleSlides[visibleSlides.length - 1].classList.add("swiper-slide-peek");
  }
}

export default function initLatestArticlesSwiper() {
  const slider = document.querySelector("[data-latest-swiper]");

  if (slider && typeof Swiper !== "undefined") {
    new Swiper(slider, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      loop: true,
      breakpoints: {
        768: { slidesPerView: 2.2 },
        1024: { slidesPerView: 2.2 },
      },
      navigation: {
        prevEl: document.querySelector("[data-latest-prev]"),
        nextEl: document.querySelector("[data-latest-next]"),
      },
      watchSlidesProgress: true,
      on: {
        slideChange: function () {
          stylePeekingSlide(this);
        },
        afterInit: function () {
          stylePeekingSlide(this);
        },
      },
    });
  }
}
